module.exports = __webpack_public_path__ + "396539ebfd96a111ceff685b9f5131c6.jpg";